import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex, Text } from "@similarweb/ui-components/foundations";

import { DetailsRow } from "../../../../common/modal/details-rows/DetailsRow";

export const StatusRow = ({ active }: { active?: boolean | null }) => {
    const { translate } = useTranslate();
    const primaryColor = active ? colorsPalettes.green[600] : colorsPalettes.carbon[400];
    const secondaryColor = active ? colorsPalettes.green[100] : colorsPalettes.carbon[50];

    return (
        <DetailsRow label={translate("activation.alerts.modal.social-ads.status")}>
            <Flex
                gap="4px"
                alignItems="center"
                background={secondaryColor}
                borderRadius="40px"
                height="20px"
                paddingX="6px"
            >
                <Box
                    background={primaryColor}
                    width="8px"
                    height="8px"
                    borderRadius="50%"
                    flexShrink={0}
                />
                <Text
                    fontVariant="captionTitle"
                    color={primaryColor}
                >
                    {active
                        ? translate("activation.alerts.modal.social-ads.status.active")
                        : translate("activation.alerts.modal.social-ads.status.inactive")}
                </Text>
            </Flex>
        </DetailsRow>
    );
};
